import { FC, useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { useTokenProvider } from 'src/context/TokenProviderContext';
import LoggedInUserContext from 'src/hooks/useLoggedInUser';
import ClassesContext from 'src/hooks/useClasses';
import { RoleTypes } from 'src/models/roles';
import UsersContext from 'src/hooks/useUsers';
import AnswersContext from 'src/hooks/useAnswers';
import { useAuthenticator } from 'src/context/AuthenticatorContext';
import AdminRouter from '../Admin/AdminRouter/AdminRouter';
import StudentRouter from '../Student/StudentRouter';
import TeacherRouter from '../Teacher/TeacherRouter';
import NotAuthenticatedRouter from '../NotAuthenticated/NotAuthenticatedRouter';
import SupervisorRouter from '../Supervisor/SupervisorRouter';
import SelectActiveRole from './SelectActiveRole/SelectActiveRole';
import FSDebugPage from './FSDebug/FSDebugPage';
import IndependenceScalePage from './IndependenceScalePage/IndependenceScalePage';

export const MainRouter: FC = () => {
  const token = useTokenProvider().getToken();
  const { activeRole } = LoggedInUserContext.useContainer();
  const { refreshToken } = useAuthenticator();
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    refreshToken();
  }, [pathname]);

  function route() {
    if (!token) return <Route path="/*" element={<NotAuthenticatedRouter />} />;
    if (!activeRole) return <Route path="/*" element={<SelectActiveRole />} />;
    return (
      <>
        <Route path="/debug/fs" element={<FSDebugPage />} />
        <Route
          path="/independence-scale"
          element={<IndependenceScalePage />}
        />
        {activeRole === RoleTypes.Student && (
          <Route path="/student/*" element={<StudentRouter />} />
        )}
        {activeRole === RoleTypes.Teacher && (
          <Route path="/teacher/*" element={<TeacherRouter />} />
        )}
        {activeRole === RoleTypes.Advisor && (
          <Route path="/advisor/*" element={<SupervisorRouter />} />
        )}
        {activeRole === RoleTypes.Admin && (
          <Route path="/admin/*" element={<AdminRouter />} />
        )}
        <Route path="/*" element={<SelectActiveRole />} />
      </>
    );
  }

  return (
    <ClassesContext.Provider>
      <AnswersContext.Provider>
        <UsersContext.Provider>
          <Routes>
            {route()}
            {/* {!token ? (
              <Route path="/*" element={<NotAuthenticatedRouter />} />
            ) : !activeRole ? (
              <Route path="/*" element={<SelectActiveRole />} />
            ) : (
              <>
                <Route path="/debug/fs" element={<FSDebugPage />} />
                <Route
                  path="/independence-scale"
                  element={<IndependenceScalePage />}
                />
                {activeRole === RoleTypes.Student && (
                  <Route path="/student/*" element={<StudentRouter />} />
                )}
                {activeRole === RoleTypes.Teacher && (
                  <Route path="/teacher/*" element={<TeacherRouter />} />
                )}
                {activeRole === RoleTypes.Advisor && (
                  <Route path="/advisor/*" element={<SupervisorRouter />} />
                )}
                {activeRole === RoleTypes.Admin && (
                  <Route path="/admin/*" element={<AdminRouter />} />
                )}
                <Route path="/" element={<SelectActiveRole />} />
              </>
            )} */}
          </Routes>
        </UsersContext.Provider>
      </AnswersContext.Provider>
    </ClassesContext.Provider>
  );
};

export default MainRouter;
